import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, of, Subject } from 'rxjs';
import { map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'app/auth/auth.service';
import { DilationWithModel } from '../Models/dilationwith.model';
import { DashboardService } from '../dashboard.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/shared/language.service';
import { DashboardModel } from '../Models/dashboard.model';
import { LocationSubFilterModel } from '../Models/locationsubfilter.model';
import { MatTableDataSource } from '@angular/material/table';
import { EMRService } from 'app/EMR/EMR.service';

export interface DialogData {
  patid: string;
  userid: number;
  uhid: number;
}

@Component({
  selector: 'app-dialation-starts',
  templateUrl: './dialation-starts.component.html',
  styleUrls: ['./dialation-starts.component.scss'],
})
export class DialationStartsComponent implements OnInit {
  destroydialation$: Subject<boolean> = new Subject<boolean>();
  stateCtrl = new FormControl();
  ctime =  new FormControl();
  ftimr =  new FormControl();
  private filteredHelplist: Observable<DilationWithModel[]>;
  private showsubmit = true;
  private drugallergy:any
  private showspinner: boolean = false;
  private selectedLanguage: any; // language varible
  private dataSource = new MatTableDataSource<DashboardModel>();
  private filteredUserArray: Observable<any[]>;
  private userCtrl: FormControl;
  color: any;
  _value: number = 0;
  _hourvalue: number = 0; // Default to 0 hours
  _step: number = 1;
  _min: number = 0;
  _max: number = 59;
  _hourmax: number = 23; // 24-hour format max value
  _wrap: boolean = false;

  hourValue: number = 0; // For hours in popup
  minuteValue: number = 0; // For minutes in popup
  private unseridlocal:any=0;
  constructor(private authService: AuthService, private dialogRef: MatDialogRef<DialationStartsComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData, private dashboardService: DashboardService,
    private datePipe: DatePipe, private translate: TranslateService,
    private langservice: LanguageService,private emrservice: EMRService,
  ) {
    dialogRef.disableClose = true;
    translate.addLangs(['en', 'fr', 'hi']);
    if (this.langservice.setlang) {
      translate.setDefaultLang(this.langservice.setlang);
    }
    else {
      translate.setDefaultLang('en');
    }
    this.unseridlocal =this.authService.Loggeduser.userid;
  }

  private _filterhelplist(value: string): DilationWithModel[] {
    const filterValue = value.toLowerCase();

    return this.dashboardService.helplist.filter(hl => hl.helpDescription.toLowerCase().indexOf(filterValue) === 0);
  }
  // convertTo12HourFormat(date: Date): string {
  //   let hours = date.getHours();
  //   let minutes = date.getMinutes();
  //   const ampm = hours >= 12 ? 'PM' : 'AM';
  //   hours = hours % 12;
  //   hours = hours ? hours : 12; // the hour '0' should be '12'
  //   const minutesStr = minutes < 10 ? '0' + minutes : minutes;
  //   return hours + ':' + minutesStr + ' ' + ampm;
  // }
  
  ngOnInit() {
    this.drugallergy = [];
    this.dashboardService.selectedeye = "RE";
    this.dashboardService.dilationwith = "";
    this.get_drugallergy(this.data.uhid);
    const currentDate = new Date();
    // Set current time
    this.hourValue = currentDate.getHours(); // Set the hour value to current hour
    this.minuteValue = currentDate.getMinutes();
    this.dashboardService.currenttime = this.datePipe.transform(currentDate, "HH:mm");

    // Add 30 minutes to current time for finish time
   
    //  this.dashboardService.finishtime = this.convertTo12HourFormat(finishDate);

    
    // this.gethelplist();

    this.filteredHelplist = this.stateCtrl.valueChanges
      .pipe(
        startWith(''),
        map(hlpls => hlpls ? this._filterhelplist(hlpls) : this.dashboardService.helplist.slice())
      );
    this.GetApplicationSetting();
    this.userCtrl = new FormControl();
    this.userCtrl.patchValue(this.authService.users.filter(data => data.pkUserId === this.unseridlocal)[0]?.userName)
    this.filteredUserArray = this.userCtrl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
   
  }
  ngOnDestroy() {
    this.destroydialation$.next(true);
    this.destroydialation$.unsubscribe();
    this.dashboardService.selectedeye=null;
    this.dashboardService.dilationwith=null;
    this.filteredHelplist=null;
    this.showsubmit=null;
    this.drugallergy = null;
  }
  GetApplicationSetting() {
    this.dashboardService.getsummary_url().pipe(takeUntil(this.destroydialation$)).subscribe((x: any) => {
      if (x.length > 0) {
        const dialationdefault = x.filter(item => item.propertyName == 'DilatationWithDrop');
        this.dashboardService.dilationwith = dialationdefault[0].propertyValue;
        if (this.dashboardService.dilationwith != null && this.dashboardService.dilationwith != '') {
          this.showsubmit = false;
        }
        const dialationdefaultime = x.filter(item => item.propertyName == 'DilatationTimeInMinutes');
         if(dialationdefaultime.length >0){
          const currentDate = new Date();
          const finishDate = new Date(currentDate.getTime() + Number(dialationdefaultime[0].propertyValue) * 60000); // Add 30 minutes
          this.dashboardService.finishtime = this.datePipe.transform(finishDate, "HH:mm");
         }else{
          const currentDate = new Date();
          const finishDate = new Date(currentDate.getTime() + 10 * 60000);
          this.dashboardService.finishtime =this.datePipe.transform(finishDate, "HH:mm");
         }
      }else{
          const currentDate = new Date();
          const finishDate = new Date(currentDate.getTime() + 10 * 60000);
          this.dashboardService.finishtime =this.datePipe.transform(finishDate, "HH:mm");
      }
    },err=>{
      if(err.status==403){
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }else{
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
 
  startdilation() {
   
    if (this.dashboardService.dilationwith.length > 40) {
      this.dashboardService.openSnackBar(this.authService.validationMsg['dashboardValidMsg.msg7'], this.authService.validationMsg['Ok']);
    } else {
      this.dashboardService.popup_cancel = false;
      this.getdilationstatus();
      this.getdilation();
    }



  }

  getdilationstatus() {
    this.dashboardService.getdialationStart(this.data.patid, this.dashboardService.currenttime,this.dashboardService.dilationwith, this.dashboardService.selectedeye, this.unseridlocal,'add',this.dashboardService.finishtime)
    .pipe(takeUntil(this.destroydialation$)).subscribe(data => this.success_dilation_starts(data),
        err => this.failed_dilation(err));
  }
  success_dilation_starts(data) {
   console.log(data,'called dialtion data')
    this.dialogRef.close(); 
  }

  failed_dilation(err) {
    this.dialogRef.close();
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("Dilation Failed", "OK");
    }
  }
  getdilation() {
    if(this.unseridlocal >0){
      this.dashboardService.getDailationstart(this.data.patid, this.unseridlocal, 'add').pipe(takeUntil(this.destroydialation$)).subscribe(data => this.success_dilation(data),
      err => this.failed_dilation_msg(err));
    }else{
      this.dashboardService.openSnackBar("Please select User", "OK");
    }
   
  }
  success_dilation(data) {
    this.dialogRef.close();
    
  }

  failed_dilation_msg(err) {
    this.dialogRef.close();
    if(err.status==403){
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }else{
      this.dashboardService.openSnackBar("Dilation Failed", "OK");
    }
  }

  onNoClick(): void {
    console.log();
    this.dashboardService.popup_cancel = true;
    this.dialogRef.close();

  }
  setValue() {
    console.log(this.dashboardService.selectedeye);
  }

  showsubmitvalue(typedValue: string) {
    if (this.dashboardService.dilationwith == "") {
      this.showsubmit = true;
    }
    else {
      this.showsubmit = false;
    }
  }

  userSearch(event:any){
    if(!event.target.value){
     this.unseridlocal =null;
    }
  }
  userfilter(event:any) {
    if (this.authService.masterdata.isUserNameLock == false) {
      this.unseridlocal =event.option.id;
      this.userCtrl.patchValue(this.authService.users.filter(data => data.pkUserId === this.unseridlocal)[0]?.userName)
    } else {
      this.dashboardService.openSnackBar(
        this.authService.validationMsg["dashboardValidMsg.msg22"],
        this.authService.validationMsg["Ok"]
      );
    }
  }


  private _filter(value: string) {
    const activeuser=this.authService.users.filter(item=>item.isActive ==true);
    const filterValue = value.toLowerCase();
    return activeuser.filter(option => option.userName.toLowerCase().includes(filterValue));
  }
 

  failed_usernamedd(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  advisedNamee(id){
    if (id != 0 && id != null) {
      return this.authService.users.filter(data => data.pkUserId === id)[0]?.userName;

  }
}
get_drugallergy(pid) {
  this.dashboardService.get_allergies(pid).pipe(takeUntil(this.destroydialation$)).subscribe(
    data => this.success_drugallergy(data), err => this.failed_drugallergy(err)
  )
}

success_drugallergy(data) {
  this.drugallergy = data;
}

failed_drugallergy(err) {

}

drugallergyNamee(id: number): string {
  const items = this.drugallergy.filter(data => data.fK_RegId === id);
  return items.length ? items.map(item => item.saltName).join(', ') : '';
}



incrementHour(step: number = 1): void {
  this.hourValue += step;
  if (this.hourValue > 23) {
    this.hourValue = 0; 
  }
}

incrementMinute(step: number = 1): void {
  this.minuteValue += step;
  if (this.minuteValue > 59) {
    this.minuteValue = 0; 
  }
}

setColor(color: string): void {
  this.color = color;
}

getColor(): string {
  return this.color;
}

incrementValue(step: number = 1): void {
  let inputValue = this._value + step;

  if (this._wrap) {
    inputValue = this.wrappedValue(inputValue);
  }
  this._value = inputValue;
  this.incrementMinute(step);
}

hoursincrementValue(step: number = 1): void {
  let hourinputValue = this._hourvalue + step;

  if (this._wrap) {
    hourinputValue = this.hourwrappedValue(hourinputValue);
  }

  this._hourvalue = hourinputValue;
  this.incrementHour(step);
}

private wrappedValue(inputValue): number {
  if (inputValue > this._max) {
    return this._min + inputValue - this._max;
  }

  if (inputValue < this._min) {
    if (this._max === 12) {
      return 0;
    }

    return this._max + inputValue;
  }

  return inputValue;
}

private hourwrappedValue(hourinputValue): number {
  if (hourinputValue > this._hourmax) {
    return this._min + hourinputValue - this._hourmax;
  }

  if (hourinputValue < this._min) {
    if (this._hourmax === 59) {
      return 0;
    }

    return this._hourmax + hourinputValue;
  }

  return hourinputValue;
}
shouldDisableDecrementForCurrentTime(): boolean {
  const currentDate = new Date();
  const currentHour = currentDate.getHours();
  const currentMinute = currentDate.getMinutes();
  if (this.hourValue < currentHour && currentHour === currentHour) {
    return true;
  }
  if (this.hourValue === currentHour && this.minuteValue < currentMinute) {
    return true;
  }

  return false;
}

shouldDisableDecrement(inputValue: number): boolean {
  return !this._wrap && inputValue <= this._min;
}

shouldDisableIncrement(inputValue: number): boolean {
  return !this._wrap && inputValue >= this._max;
}

hourshouldDisableDecrement(hourinputValue: number): boolean {
  return !this._wrap && hourinputValue <= this._min;
}

hourshouldDisableIncrement(hourinputValue: number): boolean {
  return !this._wrap && hourinputValue >= this._hourmax;
}


selectedTimeType: string;

surgeryReportTime(type: string) {
  this.selectedTimeType = type;
  const time = type === 'currenttime' ? this.dashboardService.currenttime : this.dashboardService.finishtime;
  const [hours, minutes] = time.split(':');
  this.hourValue = parseInt(hours, 10);
  this.minuteValue = parseInt(minutes.split(' ')[0], 10);
  document.getElementById("surgeryTimeModal").style.display = "block";
}

CancelsurgeryTime() {
  document.getElementById("surgeryTimeModal").style.display = "none";
}
addTime() {
  if (this.hourValue > 23 || this.minuteValue > 59 || this.minuteValue < 0 || this.hourValue < 0) {
    alert("Select Valid Time");
    return;
  }
  const date = new Date();
  date.setHours(this.hourValue, this.minuteValue);
  const formattedTime = this.datePipe.transform(date, 'HH:mm');
  const currentTime = this.datePipe.transform(new Date(), 'HH:mm');
  if (this.selectedTimeType === 'finishtime') {
    const startTime = this.dashboardService.currenttime;
    const finishTime = formattedTime;
    // Validate that finish time is greater than or equal to start time
    if (startTime && finishTime && finishTime < startTime) {
      this.dashboardService.openSnackBar("Please select a proper time. Finish time should be greater than or equal to start time.", "OK");
      return;
    }
    // Validate that finish time is not less than the current time
    if (finishTime < currentTime) {
      this.dashboardService.openSnackBar("Finish time should not be less than the current time.", "OK");
      return;
    }
    this.dashboardService.finishtime = finishTime;
  } else if (this.selectedTimeType === 'currenttime') {
    const startTime = formattedTime;
    const finishTime = this.dashboardService.finishtime;
    // Validate that start time is not less than the current time
    if (startTime < currentTime) {
      this.dashboardService.openSnackBar("Start time should not be less than the current time.", "OK");
      return;
    }
    // Validate that start time is not greater than the finish time
    if (finishTime && startTime > finishTime) {
      this.dashboardService.openSnackBar("Start time should not be greater than finish time.", "OK");
      return;
    }
    this.dashboardService.currenttime = startTime;
  }
  this.CancelsurgeryTime();
}
  closedialog() {
    this.dialogRef.close();
  }
}